import { render } from "./cell_bolder.vue?vue&type=template&id=59305dd2"
import script from "./cell_bolder.vue?vue&type=script&lang=ts"
export * from "./cell_bolder.vue?vue&type=script&lang=ts"

import "./cell_bolder.vue?vue&type=style&index=0&id=59305dd2&lang=less"
script.render = render

export default script